module.exports = __webpack_public_path__ + "static/media/banner-frio-de-lascar-pb.7f7c57a6.jpg";